import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import { InfoContainer, Text } from "$components";
import EditButton from "../components/EditButton";
import { useStyles } from "../styles";
import { ProjectDetailsLogic } from "../types";

type ProjectGeneralInfoProps = Pick<
  ProjectDetailsLogic,
  "project" | "canEdit" | "isProjectDisabled" | "handleEditProject"
>;

export default function ProjectGeneralInfo({
  project,
  canEdit,
  isProjectDisabled,
  handleEditProject,
}: ProjectGeneralInfoProps) {
  const clasx = useStyles();

  return (
    <InfoContainer
      className={[clasx.projectInformationHeader, clasx.infoHeight].join(" ")}
      leftHeader={
        <div className={clasx.infoHeader}>
          <FormatListBulleted />
          <Text type="h3">Informations projet</Text>
        </div>
      }
      rightHeader={
        <EditButton
          onClick={handleEditProject}
          canEdit={canEdit}
          isProjectDisabled={isProjectDisabled}
        />
      }
    >
      <div className="about">
        <div className="left">
          <table>
            <tr>
              <td className="label">Code projet</td>
              <td className="data">{project?.code}</td>
            </tr>
            <tr>
              <td className="label">Nom projet</td>
              <td className="data">{project?.name}</td>
            </tr>
            {project?.description && (
              <tr>
                <td className="label">Description</td>
                <td className="data">{project?.description}</td>
              </tr>
            )}
          </table>
        </div>
      </div>
    </InfoContainer>
  );
}
